import ForgotPassword from './ForgotPassword';
import Login from './Login';

export default {
    ForgotPassword,
    Login
};
